/**
 * If you do not provide engagmentId it will be received from the querystinrg
 */
export  function getSimulationURL({simulationId='',user='',engagement_id='',review_id=''}={}) {
  var q={}
  if(!engagement_id) {
    //@ts-ignore
  }
  q.engagement_id=engagement_id || qs()['engagement_id'] || undefined
  q.review_id=review_id || qs()['review_id'] || undefined
  q.user=user || qs()['user'] || undefined

  return "/library/simulation/" + simulationId + '?' + require('qs').stringify(q)
}

/**
 * If you do not provide engagmentId it will be received from the querystinrg
 */
export  function getLibraryURL({engagement_id='',user='',review_id=''}={}) {
  var q={}
    //@ts-ignore
  q.engagement_id=engagement_id || qs()['engagement_id'] || undefined
  q.review_id=review_id || qs()['review_id'] || undefined
  q.user=user || qs()['user'] || undefined
  
  return "/library?" + require('qs').stringify(q)
}

export function qs(){
  return require('qs').parse(location.search.slice(1))
}